// import React from "react";

// const CarLoanCalculator = () => {
//   return (
//     <section
//       className="space overflow-hidden"
//       style={{
//         backgroundImage: "url('/img/bg/contact-bg-1.jpg')",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <div className="container">
//         <div className="row gx-60 gy-40">
//           {/* Left Side – Form */}
//           <div className="col-lg-7 col-xl-7">
//             <div className="contact-form-v1-wrap mb-4">
//               <div className="title-area mb-35">
//                 <h4 className="sec-title mb-0">Car Loan Calculator</h4>
//                 <p className="box-text">
//                   Estimate your monthly auto loan payments with this calculator.
//                 </p>
//               </div>

//               <form
//                 action="https://html.themehour.net/kars/demo/mail.php"
//                 method="POST"
//                 className="quote-form ajax-contact"
//               >
//                 <div className="row">
//                   <div className="form-group col-md-6">
//                     <label htmlFor="Priceofvehicles">Price of vehicles</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="Priceofvehicles"
//                       placeholder="$20000"
//                     />
//                   </div>

//                   <div className="form-group col-md-6">
//                     <label htmlFor="Interest_Rate">Interest Rate</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="Interest_Rate"
//                       placeholder="10%"
//                     />
//                   </div>

//                   <div className="form-group col-md-6">
//                     <label htmlFor="Terms">Terms</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="Terms"
//                       placeholder="10 Years"
//                     />
//                   </div>

//                   <div className="form-group col-md-6">
//                     <label htmlFor="Down_payment">Down payment</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="Down_payment"
//                       placeholder="Down payment"
//                     />
//                   </div>

//                   <div className="col-12">
//                     <ul className="contact-form__bottom">
//                       <li>
//                         <p>Down payment amount</p>
//                         <p>$12,000</p>
//                       </li>
//                       <li>
//                         <p>Amount financed</p>
//                         <p>$8,000</p>
//                       </li>
//                       <li>
//                         <p>Monthly payment</p>
//                         <p>$480.00</p>
//                       </li>
//                     </ul>
//                   </div>

//                   <div className="form-btn col-12">
//                     <button className="th-btn bg-black w-100" type="submit">
//                       Apply for loan <i className="fas fa-arrow-up-right"></i>
//                     </button>
//                   </div>
//                 </div>
//                 <p className="form-messages mb-0 mt-3"></p>
//               </form>
//             </div>

//             {/* Latest Info */}
//             <div className="contact-form__latest-info bg-theme">
//               <div className="thumb">
//                 <img
//                   src="/img/icon/client-img.png"
//                   alt="clients"
//                 />
//               </div>
//               <div className="content">
//                 <h6>2345 people used kars in the last 24 hours</h6>
//               </div>
//             </div>
//           </div>

//           {/* Right Side Content */}
//           <div className="col-lg-5 col-xl-5">
//             <div className="contact-box-1-right">
//               <div className="title-area">
//                 <h2 className="sec-title text-white">
//                   Want to Calculate Your Car Payment?
//                 </h2>
//                 <p>
//                   Most dealerships offer trade-in programs where customers can
//                   bring their old vehicle, which is appraised, and the value is
//                   credited towards the purchase of new or used car.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CarLoanCalculator;




import React, { useState } from "react";

const CarLoanCalculator = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    pickup: "",
    drop: "",
    date: "",
    urbaniaType: "13 Seater Force Urbania",
    tripType: "Outstation",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappMessage = `
🚐 *Urbania Booking Enquiry – Pune*

👤 Name: ${formData.name}
📞 Phone: ${formData.phone}
📍 Pickup: ${formData.pickup}
📍 Drop: ${formData.drop}
🗓 Journey Date: ${formData.date}
🚍 Vehicle: ${formData.urbaniaType}
🧭 Trip Type: ${formData.tripType}
💬 Message: ${formData.message}
    `;

    const whatsappUrl = `https://wa.me/919209423113?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <section
      className="space overflow-hidden"
      style={{
        backgroundImage: "url('/img/bg/contact-bg-1.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="row gx-60 gy-40">
          {/* LEFT – FORM */}
          <div className="col-lg-7">
            <div className="contact-form-v1-wrap mb-4">
              <div className="title-area mb-35">
                <h4 className="sec-title mb-0">Urbania on Rent in Pune</h4>
                <p className="box-text">
                  Book Force Urbania for corporate travel, weddings, tours &
                  outstation journeys.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="quote-form">
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Your Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Full Name"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Mobile Number</label>
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="+91 XXXXX XXXXX"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Pickup Location</label>
                    <input
                      type="text"
                      name="pickup"
                      className="form-control"
                      placeholder="Pune"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Drop Location</label>
                    <input
                      type="text"
                      name="drop"
                      className="form-control"
                      placeholder="Destination"
                      onChange={handleChange}
                    />
                  </div>

                <div className="form-group col-md-6">
  <label>Journey Date</label>
  <input
    type="date"
    name="date"
    className="form-control"
    min={new Date().toISOString().split("T")[0]} // prevents past dates
    onChange={handleChange}
  />
</div>
                  <div className="form-group col-md-6">
                    <label>Urbania Type</label>
                    <select
                      name="urbaniaType"
                      className="form-control"
                      onChange={handleChange}
                    >
                    <option>10 Seater Force Urbania</option>
<option>12 Seater Force Urbania</option>
<option>13 Seater Force Urbania</option>
<option>14 Seater Force Urbania</option>
<option>17 Seater Force Urbania</option>
<option>20 Seater Bus</option>
                    </select>
                  </div>

                  <div className="form-group col-md-12">
                    <label>Trip Type</label>
                    <select
                      name="tripType"
                      className="form-control"
                      onChange={handleChange}
                    >
                      <option>Outstation</option>
                      <option>Local</option>
                      <option>Corporate</option>
                      <option>Wedding / Event</option>
                      <option>Airport Transfer</option>
                    </select>
                  </div>

                  <div className="form-group col-md-12">
                    <textarea
                      name="message"
                      className="form-control"
                      rows="3"
                      placeholder="Additional requirements..."
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="form-btn col-12">
                    <button className="th-btn bg-black w-100" type="submit">
                      Book Urbania on WhatsApp{" "}
                      <i className="fab fa-whatsapp"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* RIGHT – CONTENT */}
          <div className="col-lg-5">
            <div className="contact-box-1-right">
              <div className="title-area">
                <h2 className="sec-title text-white">
                  Luxury Urbania Rental Service
                </h2>
                <p>
                  We provide Force Urbania on rent in Pune with professional
                  drivers, pushback seats, air-conditioning, and premium comfort
                  for long-distance travel.
                </p>
                <ul className="text-white">
                  <li>✔ Corporate & Business Travel</li>
                  <li>✔ Wedding & Event Transportation</li>
                  <li>✔ Outstation Tours & Sightseeing</li>
                  <li>✔ Clean, GPS-enabled Vehicles</li>
                </ul>
                <p className="mt-3 text-white">
                  📞 WhatsApp Booking: <strong>+91 9209423113</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CarLoanCalculator;
